import { createFileRoute, notFound, redirect } from '@tanstack/react-router';
import { FeatureFlag, RouteName, TextKey } from '@mews-commander/enums';
import { checkEnterprisePrivilege } from '@mews-commander/legacy-entities';
import { RoutingRulesEditView } from '@mews-commander/modules/src/modules/routingRulesNew';
import { OptimusProvider, QueryBoundary } from '@mews-commander/ui';
import { MewsTeam, RouteType } from '@mews/enums';

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/RoutingRule/Detail/$routingRuleId')({
    loader: async ({
        params: { routingRuleId, currentEnterpriseId },
        context: { getState__DO_NOT_USE_OR_YOU_WILL_BE_FIRED: getState, featureFlagService, ensureQueryData },
    }) => {
        const isNewRoutingRulesOnAddEnabled = featureFlagService.hasFlag(FeatureFlag.newRoutingRulesOnAddEnabled);
        if (!isNewRoutingRulesOnAddEnabled) {
            throw redirect({
                to: '/$currentEnterpriseId/RoutingRule/DetailLegacy/$routingRuleId',
                params: { currentEnterpriseId, routingRuleId },
                search: { EnterpriseId: currentEnterpriseId },
            });
        }
        const state = getState();

        if (!checkEnterprisePrivilege(state, { enterpriseId: currentEnterpriseId })) {
            throw notFound();
        }

        const { routingRules } = await ensureQueryData('routingRules', 'newGetAll', {
            routingRuleIds: [routingRuleId],
        });

        return {
            title: () => routingRules?.[0]?.name,
        };
    },
    component: Component,
    staticData: {
        title: TextKey.BillingAutomation,
        routeName: RouteName.RoutingRuleDetail,
        owner: MewsTeam.Spacetime,
        type: RouteType.Frontend,
    },
});

function Component() {
    const { routingRuleId, currentEnterpriseId: enterpriseId } = Route.useParams();

    return (
        <OptimusProvider density="spacious">
            <QueryBoundary loader="overlay">
                <RoutingRulesEditView routingRuleId={routingRuleId} enterpriseId={enterpriseId} />
            </QueryBoundary>
        </OptimusProvider>
    );
}
